
import React, { useState } from 'react';
import { useRouter } from "next/router";
import Pagination from "react-js-pagination";
import ClipLoader from "react-spinners/ClipLoader";
import styles from "../../../styles/Master.module.scss";
import ReviewItem from "../../../components/Comments/ReviewItem";
import hooks from "./ReviewHooks";
function Review(props) {
    const { review, translate, get_review } = hooks(props);
    const { locale } = useRouter();
    return (
        <div className="d-flex flex-column review-list">
            {review.results && !review.loading
                ? review.results.map((item, index) => {
                    return <ReviewItem
                        key={index}
                        item={item}
                        language_code={locale}
                    />
                })
                : null}
            {review.loading
                ? <div className={styles.loader_cont}>
                    <ClipLoader color="#464646" size={15} />
                </div>
                : null}
            {review.count > 10 && !review.loading ?
                <div className={styles.pagination}>
                    <Pagination
                        activePage={review.page ? review.page : 1}
                        itemsCountPerPage={10}
                        totalItemsCount={review.count}
                        pageRangeDisplayed={5}
                        onChange={(page) => {
                            get_review({ page: page - 1, offset: (page - 1) * 10 })
                        }}
                    />
                </div>
                : null}
        </div>
    )
}
export default Review;